import { render, staticRenderFns } from "./FRegionDialog.vue?vue&type=template&id=f1d947a0&scoped=true"
import script from "./FRegionDialog.vue?vue&type=script&lang=js"
export * from "./FRegionDialog.vue?vue&type=script&lang=js"
import style0 from "./FRegionDialog.vue?vue&type=style&index=0&id=f1d947a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1d947a0",
  null
  
)

export default component.exports